import { gql } from '@apollo/client';

/**
 * `$withStaffFields` — `price` / `currency` закрыты на бэкенде ролями на
 * уровне ПОЛЯ (`GROUP_STAFF_FIELDS_ROLES` = `MANAGEMENT_ROLES`); методист,
 * которому `allGroups` открыт, получал на них «The request contains a field
 * for which you do not have permission». Передаётся из
 * `useGroupPermissions().canReadGroupStaffFields`.
 */
export const GroupsQuery = gql`
  query PaginatedGroups(
    $query: String
    $first: Int
    $after: String
    $withStaffFields: Boolean!
  ) {
    allGroups(query: $query, first: $first, after: $after) {
      totalCount
      pageInfo {
        startCursor
        endCursor
        hasNextPage
        hasPreviousPage
      }
      edges {
        cursor
        node {
          id
          name
          startDate
          lessonsCount
          studentsCount
          classesDays {
            weekDay
          }
          publishedLms
          publishedLmsForTeacher
          publishedLmsForMethodist
          price @include(if: $withStaffFields)
          currency @include(if: $withStaffFields)
          contributionsSum
        }
      }
    }
  }
`;

export const EditingGroupQuery = gql`
  query loadEditingGroup($groupId: ID!) {
    group(groupId: $groupId) {
      id
      name
      price
      currency
      startDate
      deleteAvailable
      course {
        id
        name
      }
      classesDays {
        id
        weekDay
        startTime
        endTime
      }
      modules {
        id
        name
        lessons {
          edges {
            node {
              id
              name
              lessonNumber
              additional
              date
              lmsDescription
              teacherApplication {
                id
                teacher {
                  fullName
                }
              }
            }
          }
        }
      }
    }
  }
`;
